<template>
  <svg :x="`${svg.x}%`" :y="`${svg.y}%`" :width="`${svg.width}%`" :height="`${svg.height}%`">

    <!-- debugger
    <rect x="0" y="0" width="100%" height="100%" style="stroke:green; stroke-width:1; fill:none;"/>
    -->

    <!--
    SVG с искожаемым контентом при измении соотношения сторон
    тут размещаем график. Если меток не нужно то этот SVG можно сделать родительским
    -->
    <svg x="0%" y="0%" width="100%" height="100%"
      :viewBox="`${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`"
      preserveAspectRatio="none">
      <!-- debugger
      <rect x="0" y="0" width="100%" height="100%" style="stroke:red; stroke-width:1; fill:none;"/>
      -->

      <!-- eslint-disable -->
      <template v-for="bar in bars">
        <template v-for="rect in bar">
          <rect :x="rect.x" :y="rect.y" :width="rect.width" :height="rect.height" :fill="rect.fill" class="pointer"></rect>
        </template>
      </template>
      <!-- eslint-enable -->

    </svg>

    <g class="label">
      <text v-for="(label, index) in labels" :key="index" :x="`${label.x}%`" :y="`${label.y}%`" :fill="label.fill">
        <tspan dy="-4">{{ label.text }}</tspan>
      </text>
    </g>

  </svg>
</template>

<script>
export default {
  inject: ['getSvg', 'getViewBox', 'childDataUpdated'],
  props: {
    data: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      barsRange: null,
      domainRange: null,
      bars: [],
      labels: []
    }
  },
  computed: {
    viewBox () {
      return this.getViewBox()
    },
    svg () {
      return this.getSvg()
    }
  },
  watch: {
    data (_new, _old) {
      this.childDataUpdated()
    }
  },
  methods: {
    getDomainRange () {
      this.recalculateBarsRange()
      this.domainRange = {
        xDRange: { min: 0, max: this.barsRange.max, absolute: false },
        yDRange: { min: Math.min(...this.data.map(d => d.y)), max: Math.max(...this.data.map(d => d.y)), absolute: true }
      }
      return this.domainRange
    },
    render (mappers) {
      this.renderBars(mappers)
      this.renderLabels(mappers)
    },
    renderBars (mappers) {
      let barWidth = mappers.length.y(0.8)
      barWidth = barWidth !== 0 ? barWidth : this.viewBox.height * 0.8

      this.bars = this.data.map(({ x, y }) => {
        return x.bars.reduce((acc, { value, color }) => {
          acc.unshift({
            x: acc.length > 0 ? (acc[0].x + acc[0].width) : 0,
            y: mappers.real.y(y) - barWidth,
            width: mappers.length.x(value),
            height: barWidth,
            fill: color
          })
          return acc
        }, [])
      })
    },
    renderLabels (mappers) {
      // рассчет offset чтобы поместить label в конец родительской плоскости
      const offset = (100 - this.svg.x - this.svg.width) * 100 / this.svg.width
      this.labels = this.data.map(({ x, y }) => {
        return {
          x: mappers.percent.x(this.domainRange.xDRange.max) + offset,
          y: mappers.percent.y(y),
          text: x.label.text,
          fill: x.label.color
        }
      })
    },
    recalculateBarsRange () {
      const max = this.data.reduce((max, { x }) => {
        const sum = x.bars.reduce((sum, { value }) => { return value + sum }, 0)
        return Math.max(max, sum)
      }, 0)
      this.barsRange = { min: 0, max: max }
    }
  }
}
</script>

<style lang="scss" scoped>
svg * {
  overflow: visible;
  vector-effect: non-scaling-stroke;
}
.label {
  text-anchor: end;
  font-size: 14px;
}
</style>
